exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".minVh[data-v-1fc4cbf0]{min-height:70vh}", ""]);

// exports
